export default "__VITE_ASSET__rn_zameC__"